const isObject = (x: unknown): x is Record<string, unknown> => {
  return typeof x === 'object' && x!.constructor === Object;
};

export default isObject;
